export default {
    setLoader: (state, {visible, message = ''}) => {
        state.loader = visible
        state.loaderMessage = message
    },
    setAllFoundationsTab: (state, payload) => {
        state.allFoundationsTab = payload
    }
}
